<uni-text-body
  level="050"
  [isUppercase]="false"
>
  <ng-content></ng-content>
</uni-text-body>
